"use strict";
/* Extracts values from window.measuredApp for client-specific settings */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var locale2_1 = __importDefault(require("locale2"));
var measurement_unit_1 = require("../models/measurement_unit");
var anyWindow = window;
var measuredSetting = function (key) {
    return anyWindow
        && anyWindow.measuredApp
        && anyWindow.measuredApp[key];
};
/* change the image slider zoom level */
exports.zoomLevel = function () {
    return measuredSetting("zoomLevel") || 1.5;
};
/* force a unit to display by default */
exports.defaultUnit = function () {
    var defaultSetting = measuredSetting("forceDefaultUnit");
    if (defaultSetting === "imperial") {
        return measurement_unit_1.imperial;
    }
    if (defaultSetting === "metric") {
        return measurement_unit_1.metric;
    }
    return locale2_1.default === "en-US" ? measurement_unit_1.imperial : measurement_unit_1.metric;
};
/* hide inline text on buttons */
exports.showButtonText = function () {
    return !!measuredSetting("showButtonText");
};
exports.sizeChartIcon = function () {
    return measuredSetting("sizeChartIcon") || "fa-tshirt";
};
